import { setItem } from "../../common/localStorage";

const CLAIM_TYPES_WITHOUT_VIEW = ["offlineClaim", "doctorVisit", "healthScan"];

const navigateToClaim = (navigate, key) => {
  navigate("/Add-claim", { state: key });
  setItem("productId", key?.productId);
};

const navigateToViewClaim = (navigate, key, fromClaim) => {
  navigate("/view-claim", { state: { ...key, fromClaim } });
  setItem("productId", key?.productId);
};

export const claimsListColumns = (navigate, options = {}) => [
  {
    title: "Claim Name",
    dataIndex: "claimName",
    key: "claimName",
    sorter: {
      compare: (a, b) => a.claimName.localeCompare(b.claimName),
    },
  },
  {
    title: "Claim type",
    dataIndex: "claimType",
    key: "claimType",
    sorter: {
      compare: (a, b) => a.claimType.localeCompare(b.claimType),
    },
    render: (key) => {
      return (
        <div>{key === "url" && "Redirection Url" || key === "form" && "Form" || key === "quiz" && "Quiz" ||key==="offlineClaim"&&"Offline Claim" || key === "doctorVisit" && "Doctor Visit" || key === "healthScan" && "AI Healthscan"}</div>
      );
    },
  },
  {
    title: "Language",
    dataIndex: "language",
  },

  {
    title: "Claim Status",
    dataIndex: "claimStatus",
    key: "claimStatus",
    sorter: {
      compare: (a, b) => a.claimStatus.localeCompare(b.claimStatus),
      multiple: 3,
    },
    render: (key) => {
      return (
        <div className={key === "Active" ? "activted" : "inactive"}>{key}</div>
      );
    },
  },

  {
    title: "Action",
    render: (key) => {
      if (!options.showManage && !options.showView) {
        return null;
      }

      if (
        options.showView &&
        CLAIM_TYPES_WITHOUT_VIEW.includes(key?.claimType)
      ) {
        return <div>-</div>;
      }

      return (
        <div className="action-icons">
          <div>
            {options.showManage && (
              <button
                className="manage"
                onClick={() => navigateToClaim(navigate, key)}
              >
                Manage
              </button>
            )}
            {options.showView && (
              <button
                className="manage"
                onClick={() => navigateToViewClaim(navigate, key, options.fromClaim)}
              >
                View
              </button>
            )}
          </div>
        </div>
      );
    },
  },
];
